import {da, de, enUS, fr, nl} from "date-fns/locale";
import * as React from "react";
import {forwardRef, useState} from "react";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {useTranslation} from "react-i18next";
import {useMediaQuery} from "react-responsive";
import {Button, ButtonStyles} from "../../../lib/form/Button/Button";

registerLocale("de", de);
registerLocale("da", da);
registerLocale("en", enUS);
registerLocale("fr", fr);
registerLocale("nl", nl);

interface IShippingDateProps {
  deliveryDate: string | null;
  onDeliveryDateChange: (date: string | null) => void;
}

/**
 * row to set desired delivery date
 * @param props
 * @constructor
 */
const ShippingDatePicker: React.FC<IShippingDateProps> = (props: IShippingDateProps) => {
  const {t} = useTranslation("checkout");
  const {deliveryDate, onDeliveryDateChange} = props;
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    !!deliveryDate ? new Date(Date.parse(deliveryDate)) : null,
  );
  const isMobile = useMediaQuery({
    query: "(max-width:768px)",
  });
  const reference = React.createRef<HTMLButtonElement>();
  const locale: string = (document.querySelector("html") as HTMLHtmlElement).getAttribute("lang") ?? "de";
  const DatePickerInput = forwardRef<HTMLButtonElement>(({value, onClick}: any, ref) => (
    <Button styles={[ButtonStyles.datepicker]} action={onClick}>
      {value ? value.toString() : t("Wunschdatum")}
    </Button>
  ));

  return (
    <div className="DeliveryDate ArrowBorder">
      <div>{t("Bitte versenden Sie die Ware erst am")}:</div>
      <div>
        <DatePicker
          selected={selectedDate}
          onChange={(date: Date) => {
            setSelectedDate(date);
            onDeliveryDateChange(
              !date ? null : `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`,
            );
          }}
          withPortal={isMobile}
          customInput={<DatePickerInput ref={reference} />}
          locale={locale}
          dateFormat={"P"}
          minDate={new Date()}
          isClearable
        />
      </div>
    </div>
  );
};

export default ShippingDatePicker;

export const pad = (num: number): string => {
  return `00${num}`.slice(-2);
};
